











import { Component, Vue, State, Getter } from "nuxt-property-decorator";
import { CookieBanner as CBanner } from "@byted/tiktok-sdk-vue";
import { isUseGTMByRegion } from '~/utils/gtm'
import { GTM_KEY } from '~/types/gtm'
import { EURO_COUNTRY_LIST } from "~/const/ttRegion";
// import { LANGUAGE_LIST } from "~/const/locale";

type CookieConsent = {
  ga: boolean;
  fbp: boolean;
  lip: boolean;
  af: boolean;
  bing: boolean;
  rtbhouse: boolean;
  ttads: boolean;
  linkedin: boolean;
  reddit: boolean;
  xandr: boolean;
};

@Component({
  name: "CookieBanner",
  components: { CBanner }
})
export default class CookieBanner extends Vue {
  @State(state => state.user.needCookieBanner) needCookieBanner: boolean;
  @Getter("langType") langType: string;

  $refs: {
    banner: Vue & {
      region: string;
      handleConfirm: () => void;
      handleDecline: () => void;
      i18n: {
        cookieBannerTitle: string;
        cookieBannerTitleNew: string;
        cookieBannerSubTitle: string;
        cookieBannerSubTitleNew: string;
        cookieBannerBtnManage: string;
        cookieBannerBtnDecline: string;
        cookieBannerBtnAccept: string;
      };
      policyLink: string;
      lang: string;
      showDeclineButton: boolean
    };
  };

  onAccept() {}

  getCookieConsents(consents: CookieConsent) {
    const region = this.$refs?.banner?.region
    if (!EURO_COUNTRY_LIST.includes(region)) {
      // not EEA area, load all pixel
      return this.initGTM();
    }
    const canLoad = Object.values(consents).some(val => val === true);
    if (canLoad) {
      window.gtm_permission = {
        ...(window.gtm_permission || {}),
        [GTM_KEY.FBP]: consents.fbp,
        [GTM_KEY.GA]: consents.ga,

        [GTM_KEY.LIP]: consents.lip,
        [GTM_KEY.BP]: consents.bing,
        [GTM_KEY.RTBHOUSE]: isUseGTMByRegion(GTM_KEY.RTBHOUSE, region) && consents.rtbhouse,
        [GTM_KEY.TT_ADS]: consents.ttads,
        [GTM_KEY.LINKEDIN]: consents.linkedin,
        [GTM_KEY.REDDIT]: consents.reddit,
        [GTM_KEY.XANDR]: consents.xandr
      };

      this.initGTM();
    } else {
      this.$emit("init", this.getBannerInfo());
    }
  }

  initGTM() {
    if (typeof window.initGA === "function") {
      window.initGA()
    }
  }

  onConfirm() {
    this.$refs.banner.handleConfirm();
  }

  onDecline() {
    this.$refs.banner.handleDecline();
  }

  getBannerInfo() {
    try {
      const {i18n, showDeclineButton} = this.$refs.banner

      return {
        lang: this.$refs.banner.lang,
        policyLink: this.$refs.banner.policyLink,
        title: showDeclineButton ?  i18n.cookieBannerTitleNew : i18n.cookieBannerTitle,
        detail: showDeclineButton ?  i18n.cookieBannerSubTitleNew : i18n.cookieBannerSubTitle,
        policyButton: i18n.cookieBannerBtnManage,
        declineButton: showDeclineButton ? i18n.cookieBannerBtnDecline : '',
        acceptButton: i18n.cookieBannerBtnAccept,
      };
    } catch (error) {
      return {}
    }
  }

  onShow() {}
}
